const CREDENTIAL_CLASS_NAME = 'Credential'

export {
  CREDENTIAL_CLASS_NAME
}
